export default () => {
  //Navigation Header
  const navigationHeader = document.querySelectorAll('.js-NavigationHeader');
  if(navigationHeader){
    navigationHeader.forEach(nav => { 
      for (let i = 0; i < nav.childNodes.length; i++) { 
        if(nav.childNodes[i].firstElementChild){
          let anchorActive = nav.childNodes[i].firstElementChild;
          if(anchorActive.classList.contains('is-active')){
              let activeItem = anchorActive.parentNode.parentNode.parentNode.firstElementChild;
              activeItem.classList.add('is-active');
          } 
        }
      }
       
    });
  } 

};
